// @flow
export default [
  {
    text: 'appshell.footer.legalNotice',
    link: 'appshell.links.legalWarning',
    target: '_self',
    pageSlug: 'merchant-legal-warning'
  },
  {
    text: 'appshell.footer.termsAndCons',
    link: 'appshell.links.termsAndCons',
    target: '_self',
    pageSlug: 'terms-and-conditions'
  },
  {
    text: 'appshell.footer.privacyPolicy',
    link: 'appshell.links.privacyPolicy',
    target: '_self',
    pageSlug: 'merchant-privacy-policy'
  },
  {
    text: 'appshell.footer.cookiesPolicy',
    link: 'appshell.links.cookiesPolicy',
    target: '_blank',
    pageSlug: 'politica-cookies'
  },
  {
    text: 'appshell.footer.socialPolicy',
    link: 'appshell.links.socialPolicy',
    target: '_blank',
    pageSlug: 'politica-redes-sociales'
  },
  {
    text: 'appshell.footer.company',
    link: 'appshell.links.company',
    target: '_blank',
    pageSlug: 'company'
  },
  {
    text: 'appshell.footer.contact',
    link: 'appshell.links.contact',
    target: '_blank',
    pageSlug: 'faqs'
  }
]
